export default "__VITE_ASSET__AippRh0e__"